module.exports = __webpack_public_path__ + "static/media/error-bg.48c70e55.png";


//////////////////
// WEBPACK FOOTER
// ./src/themes/irontrade/error-bg.png
// module id = 1236
// module chunks = 103